<div class="login-container">
  <div class="split-layout">
    <!-- Left side with description -->
    <div class="left-side">
      <div class="content-box">
        <div class="description-container">
          <div class="text-center">
          <img *ngIf="logoImageBase64" [src]="logoImageBase64" alt="Company Logo" class="sales-icon" style="width: 200px; height: auto;" />
        </div>

          <div class="description">
            <!-- <p style="font-size: 20px;"><b>Modern Ceramic Platform</b></p> -->
            <p style="font-size: 20px;"><b>SaleDesk ERP Platform</b></p>
            <p>
              <strong>SaleDesk ERP</strong> is a smart solution to manage your business. SaleDesk
              ERP software not only helps you to manage your business but also keeps track of your
              inventory, purchases, sales, keeps track of inward & outward, Identifying Dead Stock.
              It has a full account management system also. Your business is small or large Our
              SaleDesk ERP is the right choice.
            </p>
          </div>
        </div>
      </div>
      <!-- Bottom right logo -->
      <div class="left-bottom-wrapper">
        <p class="designed-text">Designed by</p>
        <img src="../../../assets/img/logo (1).png" alt="Logo" class="left-bottom-logo">
      </div>
    </div>

    <!-- Right side with login form -->
    <div class="right-side">
      <div class="login-form-container">
        <form [formGroup]="loginForm" class="login-form">
          <center>
            <p style="font-size: 20px;"><b>Login</b></p>
          </center>

          <div class="form-group">
            <div class="form-field" *ngIf="locationCodes.length > 1">
              <!-- Location Dropdown -->
              <ng-select [items]="locationCodes" bindLabel="Code" bindValue="ID" placeholder="Select Location"
                formControlName="LocationID" (change)="getFinancialYears()" required>
              </ng-select>
            </div>
            <!-- If only one location, hide dropdown and set value -->
            <input *ngIf="locationCodes.length === 1" type="hidden" [value]="locationCodes[0]?.ID" formControlName="LocationID">

            <div class="form-field">
              <input type="text" class="form-control" formControlName="EmployeeCode" placeholder="Enter Employee Code"
                required #employeeCodeInput>
              <label>Employee Code</label>
            </div>
            <div class="form-field password-field">
              <input
                [type]="showPassword ? 'text' : 'password'"
                class="form-control"
                formControlName="Password"
                placeholder=" "
                required>
              <label class="f-12 font-weight-bold">Password</label>
              <span class="password-toggle" (click)="togglePasswordVisibility()">
                <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </span>
            </div>
            <div class="form-field" *ngIf="financialYears.length > 1">
              <!-- Financial Year Dropdown -->
              <ng-select [items]="financialYears" bindLabel="Code" bindValue="ID" placeholder="Select Financial Year"
                formControlName="FinancialYear" required>
              </ng-select>
            </div>
            <!-- If only one financial year, hide dropdown and set value -->
            <input *ngIf="financialYears.length === 1" type="hidden" [value]="financialYears[0]?.ID" formControlName="FinancialYear">
          </div>

          <div class="form-actions d-flex justify-content-between">
            <a href="#" data-toggle="modal" data-target="#forgotPasswordModal"
              class="text-decoration-none d-flex align-items-center">Forgot Password?</a>
            <button type="submit" class="btn-login btn btn-danger btn-sm mr-1" (click)="login()"
              style="font-size: 14px;">Login</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Forgot Password Modal -->
<div class="modal fade" id="forgotPasswordModal" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Forgot Password</h4>
        <button type="button" class="close" data-dismiss="modal">×</button>
      </div>

      <div class="modal-body">
        <form [formGroup]="forgotPasswordForm">
          <!-- Send OTP Section -->
          <div *ngIf="showSendOTP">
            <div class="form-field">
              <ng-select [items]="locationCodes" bindLabel="Code" bindValue="ID" placeholder="Select Location"
                formControlName="LocationID" required>
              </ng-select>
            </div>

            <div class="form-field">
              <input type="text" class="form-control" formControlName="EmployeeCode" required>
              <label>Employee Code</label>
            </div>

            <div class="form-info">
              <p>OTP will be sent to your registered mobile number</p>
              <button class="btn-danger btn-sm mr-1" (click)="forgotPasswordSendOTP()">Send OTP</button>
            </div>
          </div>

          <!-- OTP Success Message -->
          <div *ngIf="otpSuccessMss" class="alert alert-success">
            OTP sent successfully!
          </div>

          <!-- Confirm OTP Section -->
          <div *ngIf="confirmOTP">
            <div class="form-group">
              <label>Enter OTP</label>
              <input type="text" class="form-control" formControlName="OTP" required>
            </div>
            <div class="form-actions">
              <button class="btn-danger" (click)="confirmForgotPasswordOTP()">Confirm OTP</button>
              <button class="btn-secondary" (click)="forgotPasswordSendOTP()">Resend OTP</button>
            </div>
          </div>

          <!-- Change Password Section -->
          <div *ngIf="changePasswodForm">
            <div class="form-group">
              <label>New Password</label>
              <input type="password" class="form-control" formControlName="newPassword" required>
              <small>Password must be 8-12 characters long</small>
            </div>

            <div class="form-group">
              <label>Confirm Password</label>
              <input type="password" class="form-control" formControlName="confirmPassword" required>
            </div>

            <div class="form-actions">
              <button class="btn-danger" (click)="savePassword()">Save</button>
              <button class="btn-secondary" (click)="resetPasswordForm()">Reset</button>
              <button class="btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
